export default {
  // Account action types
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  GET_PROFILE: "GET_PROFILE",
  OPEN_FORGOT_PASSWORD: "OPEN_FORGOT_PASSWORD",
  OPEN_LOGIN: "OPEN_LOGIN",
  PASSWORD_RESTORE_LINK: "PASSWORD_RESTORE_LINK",
  PASSWORD_RESTORE_RESET: "PASSWORD_RESTORE_RESET"
};
